import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modalRecipeCategories from "../ui/modal/recipeCategories.js";
import * as Storage from "../lib/Storage.ts";
import {recipeSyncCache,recipeCategoriesSyncCache} from "../mealplanner/mealplannerApi.ts"
import * as actionMenu from "./action-menu-registry.ts"
import {easyScorer, applyScorer } from "../widget/searchController.js";

import MAINTPL from "../mealplanner/recipeListWidget.mustache";
import TPL_LIST from "../mealplanner/recipeList.mustache";
import Icons from "../svg/Icons.ts";
import $ from "../$.js";
var 
  theNode,
  view,
  cat,
  searchText  = '';
  
amplify.subscribe("recipeNeedRefresh",function(){
  searchText  = '';
});

function filter(recipe){
  if(cat===undefined) return true;
  return recipe.recipeCategoryIdList.indexOf(cat)!==-1;
}
actionMenu.register({
  recipeFilter(){
    var buttons = [{onclick:'recipefilter',emoji:'🥘',i18nkey:'mp.allrecipe',selected:cat===undefined, fillMenu:true}];
    recipeCategoriesSyncCache.datas.forEach(category=>{
      var button = {onclick:'recipefilter|'+category.metaId,title:category.computedName(), fillMenu:true}
      if(category.emoji){
        button.emoji = category.emoji
      }else{
        button.svg = category.icon
      }
      button.selected = (category.metaId===cat)
      
      buttons.push(button)
    })
    buttons.push({onclick:FwDatas.getPermission("recipecatlist"),svg:Icons.ic_more_horizontal,i18nkey:'mp.categoriesMore'})
    return {menu:buttons}
  },
  recipeListMenu(){
    return {menu:[
      {onclick:'recipecatlist',svg:Icons.ic_tag,i18nkey:'mp.categoriesmanage'},
      Storage.localGet('mpshowhiddenrecipe')?{onclick:'mphidehiddenrecipe',svg:Icons.ic_eye_off,i18nkey:'mp.hidehiddenrecipe'}:{onclick:'mpshowhiddenrecipe',svg:Icons.ic_eye,i18nkey:'mp.showhiddenrecipe'}
    ],position:'right'}
  }
})
Html.register({
  recipefilter(categoryId){
    searchText = '';
    cat = undefined;
    theNode.find("input[name='search']").val(searchText);
    
    cat = categoryId;
    displayRecipes()
  },
  mpshowhiddenrecipe:function(){
    Storage.localSet("mpshowhiddenrecipe","true")
    display()
  },
  mphidehiddenrecipe:function(){
    Storage.localRemove("mpshowhiddenrecipe","true")
    display()
  }
  
})

function init(node){
  theNode = node;
  amplify.subscribe("recipeRefreshed",onrefresh);
  amplify.publish("recipeNeedRefresh");
}

function destroy(node){
  theNode = null;
  amplify.unsubscribe("recipeRefreshed",onrefresh);
}

var recipeList,nodedItems;
function onrefresh(freshRecipe,freshDish,freshRecipeCategories){
  recipeList = freshRecipe;
  recipeList.sort(recipeComparator);
  display()
  displayRecipes();
}

function filterIsRecipe(recipe){
  //theNode expandable means in the meal suggestions 
  var isSuggestionWidget = theNode.data('expandable');
  
  if(isSuggestionWidget){
    return recipe.isMealSuggestion;
  }else{
    if(!recipe.isRecipe) return false;
    if(Storage.localGet("mpshowhiddenrecipe")) return true;
    return recipe.hasDetails;
  }
}

function recipeComparator(a,b){
  let delta = a.sortingIndex-b.sortingIndex;
  if(delta!==0){ 
    return delta;
  }
  return a.name.localeCompare(b.name);
}

const recipeScorer = easyScorer({name:10,ingredients:5});

function displayRecipes(){
  var filtered = recipeList.filter(recipe=>filterIsRecipe(recipe)).filter(filter);
  nodedItems = applyScorer(filtered,recipeScorer,searchText)
  
  Html.setHtml(theNode.find('.mp-recipe-list'),TPL_LIST,{
    recipeList:nodedItems
  });
  var 
    found = nodedItems.length>0,
    showEmptyAdd = (!found && (view!=='external') && searchText.length>0),
    showEmpty = !found && !showEmptyAdd;
  
  $('.mp-nomatch').toggle(showEmptyAdd).find('.mp-searched').html(i18n.get('mp.quickadd',searchText)).attr('data-fw-onclick','recipepickadd|'+searchText);
  $('.mp-noitem').toggle(showEmpty).find('.mp-searched').html(i18n.get('mp.noitem'));
}

function display(){
  theNode.data('viewexternal',view==='external');
  let data = $.extend({},theNode.data());
  data.search = !data.viewexternal;
  data.quickadd &= !data.viewexternal;
  Html.setHtml(theNode,MAINTPL,data);
  var timeout;
  theNode.find("input[name='search']").on("input",function(){
    var nodeInput = this;
    clearTimeout(timeout)  
    timeout = setTimeout(function(){
        searchText = $(nodeInput).val();
        displayRecipes();
    },200)
  })
  .on("click",function(){$(this).focus();})
  .val(searchText);


  if(recipeList){displayRecipes()}
}
  Html.registerWidget('widget/recipeList',{init:init,destroy:destroy})

export{init,destroy}